/**
 * Short-window dedupe for back-to-back duplicate chart-of-accounts fetches
 * (e.g. parent OrganisationDetails effect firing in the same tick as the COA
 * tab fallback). The single source of truth for "data is loaded" lives on the
 * organisation object itself (chartOfAccountsLoaded / chartOfAccounts), so we
 * intentionally do NOT keep a persistent "initial requested" flag here — that
 * caused refresh-time fetches whose responses landed before `organisations`
 * hydrated to be silently lost (the reducer can't merge into an undefined org
 * list) while still blocking all future retries.
 */
const chartOfAccountsBurstAt = new Map<string, number>();

export function shouldSkipChartOfAccountsBurst(
  organisationId: string,
  windowMs = 1500
): boolean {
  const now = Date.now();
  const lastAt = chartOfAccountsBurstAt.get(organisationId);
  if (lastAt != null && now - lastAt < windowMs) return true;
  chartOfAccountsBurstAt.set(organisationId, now);
  if (chartOfAccountsBurstAt.size > 200) {
    for (const [key, at] of chartOfAccountsBurstAt.entries()) {
      if (now - at > windowMs * 10) chartOfAccountsBurstAt.delete(key);
    }
  }
  return false;
}
